import getAllMakesQuery from '../../../GraphQL/Traits/getAllMakes'
import getAllTopLevelPlatformsQuery from '../../../GraphQL/Traits/getAllTopLevelPlatforms'
import getBrandLinksQuery from '../../../GraphQL/Traits/getBrandLinks'
import getCategoryLinksQuery from '../../../GraphQL/Traits/getCategoryLinks'
import getEngineLinksQuery from '../../../GraphQL/Traits/getEngineLinks'
import getEngineLinksForSiteMapQuery from '../../../GraphQL/Traits/getEngineLinksForSiteMap'
import getRearAxleLinksQuery from '../../../GraphQL/Traits/getRearAxleLinks'
import getTransmissionLinksQuery from '../../../GraphQL/Traits/getTransmissionLinks'

import { StorageAccessor } from 'Utilities/LocalStorageUtility'

export const fetchTraitNavItems = (type, url) => {
  switch (type) {
    case 'Brand':
      return getBrandItems(url)
    case 'Category':
      return getCategoryItems(url)
    case 'Make':
      return getMakeItems(url)
    case 'Engine':
      return getEngineItems(url)
    case 'NewEngine':
      return getNewEngineItems(url)
    case 'Transmission':
      return getTransmissionItems(url)
    case 'Rearaxle':
      return getRearAxleItems(url)
    case 'Platform':
      return getPlatforms(url)
    default:
      return Promise.resolve([])
  }
}

function getPlatforms(url) {
  const query = getAllTopLevelPlatformsQuery

  return requestTraitData(query, url)
}

function getBrandItems(url) {
  const query = getBrandLinksQuery

  return requestTraitData(query, url)
}

function getCategoryItems(url) {
  const query = getCategoryLinksQuery

  return requestTraitData(query, url)
}

function getMakeItems(url) {
  const query = getAllMakesQuery

  return requestTraitData(query, url)
}

function getEngineItems(url) {
  const query = getEngineLinksQuery

  return requestTraitData(query, url)
}

function getNewEngineItems(url) {
  const query = getEngineLinksForSiteMapQuery

  return requestTraitData(query, url)
}

function getTransmissionItems(url) {
  const query = getTransmissionLinksQuery
  return requestTraitData(query, url)
}

function getRearAxleItems(url) {
  const query = getRearAxleLinksQuery

  return requestTraitData(query, url)
}

function requestTraitData(query, url) {
  const fromLocalStorage = StorageAccessor.localStorage.getObj(query)
  if (fromLocalStorage) {
    return fromLocalStorage
  }

  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query: query,
    }),
    credentials: 'include',
  })
    .then((response) => {
      return response.json()
    })
    .then((response) => {
      StorageAccessor.localStorage.setObj(query, response.data.links, 720)
      return response.data.links
    })
    .catch((error) => {
      console.error('Failed Trait Nav Request', error)
      return []
    })
}
